export const statusText = {
  ON_SERVICE_JOURNEY: 'On Service Journey',
  ON_DEAD_RUN: 'On Dead Run',
  UNKNOWN: 'Unknown',
};
export const complianceText = {
  OK: 'Ok',
  FAIL: 'Fail',
  NOT_IN_SERVICE: 'Not In Service',
  UNKNOWN: 'Unknown',
};

type FaultCodeConfig = { short: string; letter: string; color: string; text: string };
export const faultCodeConfig: Record<Status.ComplianceFaults, FaultCodeConfig> = {
  DATA_OUT_OF_SYNC: {
    short: 'Data out of sync',
    letter: 'S',
    color: 'red',
    text: 'All displays have incorrect route',
  },
  DATA_PARTLY_IN_SYNC: {
    short: 'Data partly in sync',
    letter: 'S',
    color: 'yellow',
    text: 'Some displays have incorrect route',
  },
  NO_LIVE_DISPLAYS: {
    short: 'No live displays',
    letter: 'D',
    color: 'red',
    text: 'N live = 0',
  },
  DISPLAYS_MISSING: {
    short: 'Displays missing',
    letter: 'D',
    color: 'yellow',
    text: 'Expect n live, found n < expected, but n > 0',
  },
  TOO_MANY_DISPLAYS: {
    short: 'Too many displays',
    letter: 'D',
    color: 'yellow',
    text: 'Expect n live, found n> expected',
  },
  NO_PERSISTENCE_FEATURE: {
    short: 'No persistence feature',
    letter: 'P',
    color: 'red',
    text: 'When some displays missing, assume no persistence',
  },
  VERSION_NOT_UPGRADED: {
    short: 'Version not upgraded',
    letter: 'V',
    color: 'red',
    text: 'All displays are out of date',
  },
  VERSION_INCOMPLETE_UPGRADE: {
    short: 'Version incomplete upgrade',
    letter: 'V',
    color: 'yellow',
    text: 'Some displays are out of date',
  },
  MEDIA_VERSION_NOT_UPGRADED: {
    short: 'Media not upgraded',
    letter: 'M',
    color: 'read',
    text: 'Media is out of date',
  },
  MEDIA_VERSION_INCOMPLETE_UPGRADE: {
    short: 'Media incomplete upgrade',
    letter: 'M',
    color: 'yellow',
    text: 'Some media are out of date',
  },
  NO_MESSAGES_FROM_BUS: {
    short: 'No messages',
    letter: 'M',
    color: 'red',
    text: 'No MQTT messages were received (including position)',
  },
  MISCONFIGURED_DISPLAYS: {
    short: 'Misconfigured displays',
    letter: 'C',
    color: 'red',
    text: 'All displays are misconfigured',
  },
  PARTLY_MISCONFIGURED_DISPLAYS: {
    short: 'Party misconfigured displays',
    letter: 'C',
    color: 'yellow',
    text: 'Some displays are misconfigured',
  },
};
